var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var reset = {
    alignItems: 'flex-start',
    borderCollapse: 'separate',
    borderSpacing: 0,
    color: 'black',
    display: 'block',
    fontFamily: '"Open Sans", Arial, sans-serif',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 'normal',
    justifyContent: 'flex-start',
    letterSpacing: 'normal',
    lineHeight: 'normal',
    listStyleType: 'none',
    margin: 0,
    padding: 0,
    textAlign: 'left',
    textIndent: 0,
    textTransform: 'none',
    textShadow: 'none',
    verticalAlign: 'baseline',
    wordSpacing: 'normal',
};
export var disabled = {
    backgroundColor: '#DFE4E8',
    border: '#A8B2BA',
    color: '#8E9AA3',
    '&::placeholder': {
        color: '#8E9AA3',
    },
    cursor: 'not-allowed',
};
export var overflow = {
    textOverflow: 'ellipsis',
    paddingRight: '30px !important',
    whiteSpace: 'nowrap',
};
export var focus = __assign(__assign({}, overflow), { padding: '7px 11px', border: "2px solid ".concat('#2B66D6') });
export var input = __assign(__assign({}, reset), { backgroundColor: '#ffffff', border: "1px solid ".concat('#7E8A94'), borderRadius: 8, boxSizing: 'border-box', display: 'block', fontSize: 16, outline: 'none', lineHeight: 1.1, padding: '8px 12px', position: 'relative', color: '#000000', transition: 'box-shadow 0.3s ease-in-out', width: '100%', ':disabled': disabled, ':focus': focus });
export var staticSelect = __assign(__assign(__assign({}, input), overflow), { width: '100%', appearance: 'none', '&::-ms-expand': {
        display: 'none',
    } });
export var staticSelectPlaceholder = __assign(__assign({}, staticSelect), { color: '#42505C', option: { color: staticSelect.color } });
export var actions = {
    display: 'block',
    float: 'right',
    fontSize: 0,
    marginTop: '-4px',
    marginRight: '-8px',
    padding: 0,
    pointerEvents: 'none',
    position: 'absolute',
    right: 8,
    top: 6,
    zIndex: 1,
    ':active': {
        backgroundColor: '#b7c0c9',
        boxShadow: 'none',
    },
    ':focus, :focus-visible': {
        outline: "2px solid #75828c",
        '--box-shadow-color': 'unset',
    },
    ':hover': {
        backgroundColor: '#e1e5e9',
    },
    ':disabled': {
        color: "".concat('#8E9AA3', " !important"),
    },
};
export var actionButton = {
    color: '#000000',
    display: 'inline-block',
    fontSize: 'auto',
    height: '38px',
    marginLeft: '0px !important',
    marginRight: 0,
    transition: 'box-shadow 0.3s ease-in-out',
    width: 32 - 1,
    ':hover': {
        borderLeft: '1px solid #cccccc',
        color: '#a6a6a6',
    },
    ':focus, :focus-visible': {
        borderLeft: '1px solid #cccccc',
        color: '#a6a6a6',
        height: '36px',
    },
};
export var actionButtonDisabled = {
    color: '#8E9AA3',
};
export var staticSelectWrapper = {
    position: 'relative',
    width: '100%',
    div: {
        button: {
            padding: '11px 0',
            border: '0px',
            div: {
                div: {
                    i: {
                        color: '#000000',
                    },
                },
            },
        },
    },
    select: {
        height: '40px',
        alignItems: 'center',
        // this value prevents cutting off a 'g', without changing spacing
        lineHeight: '20px',
    },
};
export var disabledChevron = {
    color: '#a6a6a6 !important',
};
// Loader - Primary
export var loader = {
    display: 'flex',
    lineHeight: 0,
    zIndex: 799,
    margin: '0 5px 0 0',
    minWidth: '25px',
};
export var loadingAnimation = {
    display: 'block',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    width: 'auto',
    margin: 'auto',
    padding: 0,
    height: 8,
    '@keyframes bouncedelay': {
        '0%': {},
        '80%': {},
        '100%': {},
        '40%': {},
    },
};
// Secondary
export var activeSecondary = {
    backgroundColor: '#4b5863',
    borderColor: '#4b5863',
    color: '#ffffff',
};
export var loaderDot = {
    verticalAlign: 'middle',
    width: 8,
    height: 8,
    backgroundColor: '#a6a6a6',
    borderRadius: '100%',
    display: 'inline-block',
    animation: "bouncedelay 1200ms infinite ease-in-out",
    /* Prevent first frame from flickering when animation starts */
    animationFillMode: 'both',
};
export var loaderDot1 = {
    animationDelay: '300ms',
};
export var loaderDot2 = {
    animationDelay: '-150ms',
};
export var dropdownIconContainer = {
    width: '40px',
    height: '38px',
    marginTop: '-1px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
};
export var dropdownIcon = {
    color: '#323E48',
};
export var listRow = {
    ':hover': {
        backgroundColor: '#e293cf',
        cursor: 'pointer',
    },
};
export var inputBaseActionArea = {
    maxWidth: '80%',
    border: 'none',
    boxSizing: 'border-box',
    margin: '-1px 0 0 -1px',
    padding: '0',
    whiteSpace: 'nowrap',
};
export var inputFullContainerStyles = {
    backgroundColor: '#ffffff',
    border: '1px solid #8E9AA4',
    borderRadius: 8,
    boxSizing: 'border-box',
    fontSize: 16,
    height: '40px',
    outline: 'none',
    width: '100%',
    position: 'relative',
    display: 'flex',
    overflow: 'visible',
};
export var inputContainerBaseStyles = {
    display: 'flex',
    flexGrow: 1,
    verticalAlign: 'top',
    position: 'relative',
    overflow: 'visible',
    width: '100%',
};
export var inputDropdownFocus = {
    border: "2px solid ".concat('#2B66D6'),
    padding: '0',
    '.pcty-input-select__dropdown-icon': {
        height: '36px',
    },
};
export var inputBaseInputHolder = {
    display: 'flex',
    position: 'relative',
    flexGrow: 1,
};
export var inputBaseInputButtonContainer = {
    flex: '0 0 auto',
    width: 'auto',
    maxWidth: 'none',
    transition: 'box-shadow 0.3s ease-in-out',
};
export var fakePlaceholderStyles = {
    boxSizing: 'content-box',
    position: 'absolute',
    top: 0,
    padding: '6px 0px 0px 12px',
    left: 0,
    width: 'calc(100% - 7px)',
    lineHeight: '24px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    color: '#323E48',
};
export var inputBaseClearButton = {
    minWidth: '40px',
    color: '#323E48',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    border: 'none',
    outline: 'none',
    textDecoration: 'none',
    transition: 'box-shadow 0.3s ease-in-out',
    ':hover': {
        boxShadow: 'none',
        background: '#E1E5E9',
    },
    ':focus, :focus-visible': {
        boxShadow: 'none',
        outline: '2px solid #75828C !important',
        padding: '0 !important',
        marginRight: '0px !important',
    },
    ':active': {
        boxShadow: 'none',
        background: '#B7C0C9',
    },
};
export var clearButtonFocusStyles = {};
export var inputBaseInputStyles = {
    boxSizing: 'content-box',
    width: '100%',
    background: '0px center',
    border: '0px',
    fontSize: 'inherit',
    opacity: 1,
    outline: '0px',
    color: '#000000',
    padding: '3px 0 0 0',
};
export var inputBaseInputWrapper = {
    display: 'flex',
    flexGrow: 1,
    margin: '-4px 0px 0px 8px',
    '&::placeholder': {
        color: '#42505C',
    },
};
// dropdown icon
export var inputIconBase = {
    boxSizing: 'border-box',
    outline: 'none',
    textDecoration: 'none',
    verticalAlign: 'top',
    backgroundColor: 'transparent',
    borderColor: 'transparent',
    border: 'none',
    borderRadius: '0 6px 6px 0',
    display: 'inline-flex',
    height: '36.5px', // this is .5 for mac retina/high pixel density screens
    transition: 'box-shadow 0.3s ease-in-out',
    ':hover': {
        boxShadow: 'none',
        backgroundColor: '#E1E5E9',
    },
    ':focus, :focus-visible': {
        boxShadow: 'none',
        outline: '2px solid #75828C !important',
        border: 'none',
    },
    ':active': {
        boxShadow: 'none',
        background: '#B7C0C9',
    },
};
export var inputBaseSeparatorStyles = {
// display: 'none',
};
export var inputBaseMainContainerStyles = {
    position: 'relative',
    height: '40px',
    width: '100%',
};
export var dropdownListContainer = {
    width: '100%',
    position: 'fixed',
    zIndex: 10,
    marginTop: '6px',
};
export var inputBaseErrorState = {
    border: "2px solid ".concat('#CC0821', " !important"),
    ':focus': {
        border: "2px solid ".concat('#CC0821'),
    },
};
export var inputBaseDisabledState = {
    backgroundColor: 'white',
    border: '1px solid #c9cfd4',
    color: '#8E9AA3',
    cursor: 'not-allowed',
};
export var inputBaseNormalState = {
    backgroundColor: 'white',
    color: '#000000',
    '::placeholder': {
        color: '#42505C',
    },
};
export var inputBasePlaceholderStyles = {
    color: inputBaseNormalState['::placeholder'].color,
};
export var tagContainerStyles = {
    height: '100%',
    display: 'inline-flex',
    alignItems: 'center',
    maxWidth: '100%',
    padding: '0 0 0 8px',
};
export var dropdownListShadowStyles = {
    background: '#ffffff',
    border: "1px solid ".concat('#DFE4E8'),
    borderRadius: 8,
    boxShadow: '0px 2px 4px 0.5px rgba(50, 62, 72, 0.08)',
    boxSizing: 'border-box',
};
export var dropdownListShadowSelectAllStyles = {
    borderTopWidth: 0,
    borderRadius: '0 0 8px 8px',
    boxShadow: '0px 10px 18px rgba(166, 176, 186, 0.2)',
};
// regular (non-employee) row
export var fixedRowListStyles = {
    position: 'absolute',
    left: '4px',
    top: '105px',
    color: '#000000',
    fontWeight: 600,
    fontSize: 16,
    height: '40px !important',
    width: 'calc(100% - 8px)',
    margin: "".concat(4, "px 0"),
    boxSizing: 'border-box',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    cursor: 'pointer',
    lineHeight: '32px',
    backgroundColor: '#ffffff',
    overflow: 'hidden',
    padding: "".concat(4, "px 12px"),
    listStyle: 'none',
    borderRadius: 8,
    ':hover, :focus': {
        background: "linear-gradient(0deg, rgba(0, 0, 0, 0.04) 0%, rgba(0, 0, 0, 0.04) 100%), ".concat('#ffffff'),
    },
    ':active': {
        background: "linear-gradient(0deg, rgba(0, 0, 0, 0.08) 0%, rgba(0, 0, 0, 0.08) 100%), ".concat('#ffffff'),
    },
    ':focus, :focus-visible': {
        outline: '2px solid #75828C',
    },
};
export var disabledStyles = {
    backgroundColor: 'white',
    color: '#8E9AA3',
    '::placeholder': {
        color: '#8E9AA3',
    },
    cursor: 'not-allowed',
};
export var fixedRowListStylesSelected = {
    background: "linear-gradient(0deg, rgba(255, 255, 255, 0.00) 0%, rgba(255, 255, 255, 0.00) 100%), ".concat('#E5EFFF'),
    ':hover :focus': {
        background: "linear-gradient(0deg, rgba(255, 255, 255, 0.32) 0%, rgba(255, 255, 255, 0.32) 100%), ".concat('#E5EFFF'),
    },
    ':focus, :focus-visible': {
        outline: '2px solid #347ABE',
    },
    ':active': {
        background: "linear-gradient(0deg, rgba(0, 0, 0, 0.02) 0%, rgba(0, 0, 0, 0.02) 100%), ".concat('#E5EFFF', ";"),
    },
    '::after': {
        position: 'absolute',
        right: '16px',
        content: '" "',
        display: 'inline-block',
        backgroundSize: '50%',
        backgroundPosition: 'center center',
        backgroundRepeat: 'no-repeat',
        backgroundColor: '#1454CC',
        borderRadius: '9999px',
        backgroundImage: "url(\"data:image/svg+xml,%3Csvg id='Layer_1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 128 128'%3E%3Ctitle%3Ebold/checkmark-bold%3C/title%3E%3Cpath fill='%23FFFFFF' id='Combined-Shape' class='st0' d='M66.7 107l60.5-86.4c.6-.9.4-2.1-.5-2.8l-9.8-6.9c-.9-.6-2.1-.4-2.8.5L54.5 96.6l-44.2-31c-.9-.6-2.2-.4-2.8.5L.6 75.9c-.6.9-.4 2.1.5 2.8l45.4 31.8c.1.1.2.3.4.4l9.8 6.9c.5.4 1.2.5 1.8.3.4-.1.8-.4 1.1-.8l6.9-9.8c.1-.2.2-.4.2-.5z'/%3E%3C/svg%3E\")",
        width: "".concat(24, "px"),
        height: "".concat(24, "px"),
        top: '50%',
        marginTop: '-12px',
    },
};
export var focusedSelectAllRowStyles = {
    background: '#F5F5F5',
};
export var selectAllRowStyles = {
    margin: 0,
    width: '100%',
    left: 0,
    color: '#000000',
    background: '#ffffff',
    fontWeight: 500,
    fontSize: 16,
    minHeight: '50px !important',
    padding: 8,
    position: 'unset',
    top: 'unset',
    boxShadow: '0 0 3px rgba(0,0,0,.1)',
    border: '1px solid #dadada',
    borderRadius: '8px 8px 0 0',
    ':focus, :focus-visible': {
        outline: 'none',
    },
    ':hover': {
        background: '#ffffff',
    },
};
export var selectAllButtonStyles = {
    left: 0,
    color: '#000000',
    fontWeight: 500,
    fontSize: 16,
    margin: '0px -4px',
    padding: "".concat(8, "px ").concat(8, "px ").concat(8, "px 12px"),
    borderRadius: 8,
    ':hover': {
        background: '#e1e5e9',
    },
    ':active': {
        background: '#B7C0C9',
    },
    ':focus, :focus-visible': {
        outline: '2px solid #75828C',
    },
};
export var focusedRowStyles = {
    background: '#E1E6EB',
};
export var groupedItemStyles = {
    paddingLeft: '24px',
};
// employee row
export var fixedRowGridStyles = {
    position: 'absolute',
    left: '4px',
    top: '105px',
    height: '56px !important',
    color: '#000000',
    fontWeight: 600,
    fontSize: 16,
    width: 'calc(100% - 8px)',
    margin: '4px 0',
    boxSizing: 'border-box',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    cursor: 'pointer',
    lineHeight: '24px',
    background: '#ffffff',
    overflow: 'hidden',
    padding: "".concat(8, "px ").concat(32, "px ").concat(8, "px ").concat('12', "px"),
    listStyle: 'none',
    borderRadius: 8,
    ':hover, :focus': {
        background: "linear-gradient(0deg, rgba(0, 0, 0, 0.04) 0%, rgba(0, 0, 0, 0.04) 100%), ".concat('#ffffff'),
    },
    ':active': {
        background: "linear-gradient(0deg, rgba(0, 0, 0, 0.08) 0%, rgba(0, 0, 0, 0.08) 100%), ".concat('#ffffff'),
    },
    ':focus, :focus-visible': {
        outline: '2px solid #75828C',
    },
};
